<script setup lang="ts">
  import { PageDecorationImage } from '@/shared/ui/components'

  import { FeedbackControlForm } from '@/features/feedback-control'

  definePage({
    meta: {
      layout: 'baseNew',
      contentManagerRoute: true,
    },
  })

  const { t } = useI18n()

  useHead({
    title: () => t('navigation_item_feedback_control'),
  })
</script>

<template>
  <div class="wide-responsive flex h-full flex-col flex-nowrap! overflow-hidden">
    <div class="relative flex flex-col flex-nowrap! gap-4 border-b p-6 pt-8">
      <PageDecorationImage />

      <h1 class="heading-md text-heading!">
        {{ $t('navigation_item_feedback_control') }}
      </h1>
    </div>

    <FeedbackControlForm />
  </div>
</template>
